export default {
  actions: {
    copied: "Copied to clipboard",
    copyFailed: "Failed to copy",
    pdfDownloaded: "PDF downloaded for visit #{visitId}",
    pdfDownloadFailed: "Failed to download PDF",
    loadVisitResultsFailed: "Failed to load visit results",
    loadTestHistoryFailed: "Failed to load test history",
    loadVisitFlagsFailed: "Failed to load visit flags",
    channelStarted: "{channelName} started successfully",
    channelStartFailed: "Failed to start {channelName}",
    channelStopped: "{channelName} stopped successfully",
    channelStopFailed: "Failed to stop {channelName}",
    cacheCleared: "Server cache cleared successfully",
    cacheClearFailed: "Failed to clear server cache",
    featureNotImplemented: "This feature is not yet available",
    refreshFailed: "Could not refresh \u2014 showing last known data.",
  },

  tooltips: {
    copyBarcode: "Copy barcode to clipboard",
  },
};
